var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-upload',{attrs:{"drag":"","action":"https://jsonplaceholder.typicode.com/posts/","multiple":""}},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"el-icon-document-copy"}),_c('div',{staticClass:"el-upload__text"},[_vm._v(" 将文件拖到此处，或"),_c('em',[_vm._v("点击上传")]),_c('div',[_vm._v("支持格式xls、xlsx")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }